export async function GET() {
  const res = await fetch('http://94.72.111.23:2000/myritewallet/v1/FLEXIBLE/PENDING');
  const data = await res.json();
  return Response.json(data);
}
